export const translations = {
  fr: {
    nav: {
      studio: "Studio",
      expertise: "Expertise",
      projects: "Projets",
      process: "Processus",
      contact: "Contact",
    },
    hero: {
      overline: "Studio d'architecture — Est. 2010",
      titleL1: "Loge",
      titleL2: "d'Architecture",
      titleL3: "KERKOUB Abdelkrim",
      signature: "Loge d'Architecture KERKOUB Abdelkrim",
      subtitle:
        "Façonner l'espace avec précision technique. BIM, conception et rénovation entre Strasbourg, la France et le Luxembourg.",
      cta_primary: "Voir les projets",
      cta_secondary: "Prendre contact",
      scroll: "Défiler",
    },
    marquee: [
      "BIM • ArchiCAD",
      "REVIT • MEP",
      "Conception",
      "Rénovation",
      "Permis de construire",
      "Maîtrise d'œuvre",
    ],
    about: {
      overline: "Studio",
      title: "Une pratique ancrée entre le Rhin et la Méditerranée.",
      p1:
        "Karim Kerkoub quitte la Méditerranée en 2007 pour s'installer autour du Rhin. Diplômé de l'École d'Architecture de Strasbourg (2009) et de l'INSA Strasbourg (2010), il construit une pratique dédiée à la précision, à la matière et à la transition numérique.",
      p2:
        "Ses expériences en agences d'architecture — France, Luxembourg — lui ont permis de développer un regard transversal, du dépôt de permis de construire à la réception du projet.",
      p3:
        "LAKA propose un travail collaboratif pour l'implémentation du BIM (ArchiCAD, REVIT, BIM-MEP), en accompagnant ses clients dans la transition numérique et la mise en œuvre de projets de conception, rénovation ou d'exploitation.",
      stats: [
        { k: "15+", v: "Années de pratique" },
        { k: "2", v: "Pays d'exercice" },
        { k: "100%", v: "Projets BIM" },
      ],
    },
    expertise: {
      overline: "Expertise",
      title: "Quatre disciplines, un même rigor.",
      items: [
        {
          n: "01",
          t: "Implémentation BIM",
          d: "ArchiCAD, REVIT, BIM-MEP. Modélisation, coordination inter-métiers et transition numérique pour les studios et bureaux d'études.",
        },
        {
          n: "02",
          t: "Conception & Design",
          d: "Conception architecturale de logements individuels, collectifs et tertiaires. Recherche de matière, de lumière et de proportion.",
        },
        {
          n: "03",
          t: "Rénovation & Exploitation",
          d: "Réhabilitation technique et architecturale, mise à niveau énergétique et accompagnement dans l'exploitation des bâtiments existants.",
        },
        {
          n: "04",
          t: "Maîtrise d'œuvre complète",
          d: "Du dépôt du permis de construire à la réception du chantier : pilotage, suivi d'exécution et OPC.",
        },
      ],
    },
    projects: {
      overline: "Projets sélectionnés",
      title: "Travaux récents.",
      subtitle: "Une sélection d'études et de réalisations — résidentiel, tertiaire, rénovation.",
      filters: { all: "Tous", residential: "Résidentiel", commercial: "Tertiaire", renovation: "Rénovation" },
      view: "Voir le projet",
    },
    process: {
      overline: "Méthodologie",
      title: "Quatre phases, une trajectoire claire.",
      steps: [
        { n: "01", t: "Écoute & diagnostic", d: "Compréhension du programme, du site et du budget. Études de faisabilité." },
        { n: "02", t: "Conception & BIM", d: "Esquisse, APS, APD. Modélisation BIM complète et coordination." },
        { n: "03", t: "Permis & consultation", d: "Dépôt du permis de construire, DCE, consultation des entreprises." },
        { n: "04", t: "Chantier & livraison", d: "Suivi d'exécution, OPC, réception et assistance à l'exploitation." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Parlons de votre projet.",
      subtitle:
        "Étude, conception, BIM ou rénovation — chaque projet mérite une écoute singulière. Écrivez-nous.",
      name: "Nom",
      email: "Email",
      subject: "Sujet",
      message: "Votre message",
      send: "Envoyer le message",
      sending: "Envoi…",
      success: "Message reçu. Nous vous répondrons sous 48h.",
      error: "Une erreur est survenue. Réessayez.",
      based: "Basé à Strasbourg",
      area: "Grand Est • France • Luxembourg",
      phone: "Téléphone",
    },
    footer: {
      tagline: "Studio d'architecture & expertise BIM.",
      rights: "Tous droits réservés.",
      links: "Navigation",
      social: "Canaux",
    },
  },
  en: {
    nav: {
      studio: "Studio",
      expertise: "Expertise",
      projects: "Works",
      process: "Process",
      contact: "Contact",
    },
    hero: {
      overline: "Architecture studio — Est. 2010",
      titleL1: "Loge",
      titleL2: "d'Architecture",
      titleL3: "KERKOUB Abdelkrim",
      signature: "Loge d'Architecture KERKOUB Abdelkrim",
      subtitle:
        "Shaping space with technical precision. BIM, design and renovation between Strasbourg, France and Luxembourg.",
      cta_primary: "View projects",
      cta_secondary: "Get in touch",
      scroll: "Scroll",
    },
    marquee: [
      "BIM • ArchiCAD",
      "REVIT • MEP",
      "Design",
      "Renovation",
      "Building permits",
      "Project management",
    ],
    about: {
      overline: "Studio",
      title: "A practice rooted between the Rhine and the Mediterranean.",
      p1:
        "Karim Kerkoub left the Mediterranean in 2007 to settle along the Rhine. A graduate of the Strasbourg School of Architecture (2009) and INSA Strasbourg (2010), he has built a practice dedicated to precision, materiality and digital transition.",
      p2:
        "His work across French and Luxembourgish studios has shaped a cross-disciplinary eye — from the permit phase to final project handover.",
      p3:
        "LAKA offers collaborative BIM implementation (ArchiCAD, REVIT, BIM-MEP), supporting clients through the digital transition for design, renovation and operational projects.",
      stats: [
        { k: "15+", v: "Years of practice" },
        { k: "2", v: "Countries" },
        { k: "100%", v: "BIM-native" },
      ],
    },
    expertise: {
      overline: "Expertise",
      title: "Four disciplines, one rigor.",
      items: [
        {
          n: "01",
          t: "BIM Implementation",
          d: "ArchiCAD, REVIT, BIM-MEP. Modeling, multi-trade coordination and digital transition for studios and engineering offices.",
        },
        {
          n: "02",
          t: "Design & Conception",
          d: "Architectural design for individual houses, collective housing and tertiary buildings. A search for material, light and proportion.",
        },
        {
          n: "03",
          t: "Renovation & Operations",
          d: "Technical and architectural renovation, energy upgrades and support for operating existing buildings.",
        },
        {
          n: "04",
          t: "Full Project Management",
          d: "From permit filing to site handover: coordination, execution monitoring and scheduling (OPC).",
        },
      ],
    },
    projects: {
      overline: "Selected works",
      title: "Recent projects.",
      subtitle: "A selection of studies and built work — residential, tertiary, renovation.",
      filters: { all: "All", residential: "Residential", commercial: "Tertiary", renovation: "Renovation" },
      view: "View project",
    },
    process: {
      overline: "Methodology",
      title: "Four phases, one clear trajectory.",
      steps: [
        { n: "01", t: "Listening & brief", d: "Understanding the program, site and budget. Feasibility studies." },
        { n: "02", t: "Design & BIM", d: "Sketch, preliminary and final design. Complete BIM modeling and coordination." },
        { n: "03", t: "Permit & tender", d: "Building permit filing, technical specifications, contractor consultation." },
        { n: "04", t: "Site & handover", d: "Execution supervision, scheduling, handover and operational support." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your project.",
      subtitle:
        "Study, design, BIM or renovation — every project deserves a dedicated ear. Write to us.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Your message",
      send: "Send message",
      sending: "Sending…",
      success: "Message received. We'll reply within 48h.",
      error: "Something went wrong. Please retry.",
      based: "Based in Strasbourg",
      area: "Grand Est • France • Luxembourg",
      phone: "Phone",
    },
    footer: {
      tagline: "Architecture studio & BIM expertise.",
      rights: "All rights reserved.",
      links: "Navigation",
      social: "Channels",
    },
  },
};

export const projectsData = [
  {
    id: "mediatheque-algerie",
    title: {
      fr: "Médiathèque — Projet public / Appel d'offres",
      en: "Mediatheque — Public project / Open call",
    },
    category: "commercial",
    year: "2026",
    location: "Algérie",
    scope: "Appel d'offres public · Équipement culturel · Étude architecturale",
    featured: true,
    image:
      "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/jeidvdzd_WhatsApp%20Image%202026-04-23%20at%2014.07.37.jpeg",
    description: {
      fr:
        "Étude architecturale réalisée dans le cadre d'un appel d'offres public en Algérie. Le projet développe une réflexion autour de l'équipement culturel, de l'accueil du public, de la lecture, des espaces partagés et de l'intégration urbaine. Il illustre notre capacité à répondre à des programmes publics exigeants, avec une approche à la fois fonctionnelle, architecturale et contextuelle.",
      en:
        "Architectural study developed in the framework of a public open call in Algeria. The project explores cultural facilities, public welcoming, reading spaces, shared areas and urban integration. It illustrates our capacity to respond to demanding public programs, with a functional, architectural and contextual approach.",
    },
    gallery: [
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/3m2cqo74_WhatsApp%20Video%202026-04-23%20at%2014.07.36.mp4",
        kind: "video",
        label: { fr: "Animation 3D — Walk-through", en: "3D Animation — Walk-through" },
        type: "animation",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/jeidvdzd_WhatsApp%20Image%202026-04-23%20at%2014.07.37.jpeg",
        kind: "image",
        label: { fr: "Rendu extérieur", en: "Exterior render" },
        type: "render",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/o0gbmuxs_WhatsApp%20Image%202026-04-23%20at%2014.07.37%20%281%29.jpeg",
        kind: "image",
        label: { fr: "Planche technique — Plans, coupes & système constructif", en: "Technical board — Plans, sections & construction system" },
        type: "board",
      },
    ],
  },
  {
    id: "maison-kl",
    title: {
      fr: "Maison KL — Logements & commerces",
      en: "KL House — Housing & retail",
    },
    category: "residential",
    year: "2019",
    location: "Algérie",
    scope: "Logements + RDC commercial · Conception · Maquette",
    budget: "200 000 €",
    image:
      "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/7az6eog5_ChatGPT%20Image%2021%20avr.%202026%2C%2000_03_50.png",
    description: {
      fr:
        "Programme mixte sur parcelle d'angle : logements en R+2 surmontant un rez-de-chaussée commercial actif. Volume principal en bardage sombre — affirmation contemporaine — articulé à un volume secondaire blanc qui dialogue avec le tissu existant. La porte d'entrée en bois travaillé (ferronnerie traditionnelle) signale l'identité algéroise du projet. Le bâtiment vit jour et nuit grâce aux vitrines éclairées qui animent le trottoir.",
      en:
        "Mixed-use program on a corner plot: R+2 housing above an active retail ground floor. The main volume — dark cladding — asserts a contemporary identity, articulated against a white secondary volume that engages the existing fabric. The crafted timber entrance door (traditional ironwork) anchors the project in its Algerian context. The building lives day and night thanks to illuminated shopfronts animating the sidewalk.",
    },
    gallery: [
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/62zbufwu_Animation.mp4",
        kind: "video",
        label: { fr: "Animation 3D — Visite immersive", en: "3D Animation — Immersive walk-through" },
        type: "animation",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/7az6eog5_ChatGPT%20Image%2021%20avr.%202026%2C%2000_03_50.png",
        kind: "image",
        label: { fr: "Rendu — Vue de jour", en: "Render — Daytime view" },
        type: "render",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/wq6zgyz9_Urban_lighting_realistic_202604210010.jpeg",
        kind: "image",
        label: { fr: "Rendu — Ambiance nocturne", en: "Render — Night ambience" },
        type: "render",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/97zn2rmn_maquette%20en%20Bois.jpeg",
        kind: "image",
        label: { fr: "Maquette bois — Kerkoub Architecte", en: "Timber model — Kerkoub Architecte" },
        type: "model",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/js2c6muc_Pr%C3%A9sentation%20Plan.jpeg",
        kind: "image",
        label: { fr: "Planche — Plans & élévations", en: "Board — Plans & elevations" },
        type: "drawing",
      },
    ],
  },
  {
    id: "maison-bach-algerie",
    title: {
      fr: "Maison BACH — Rénovation & extension",
      en: "BACH House — Renovation & extension",
    },
    category: "renovation",
    year: "2018",
    location: "Algérie",
    scope: "Rénovation complète · Extension contemporaine · Requalification façade",
    surface: "420 m²",
    budget: { fr: "Non communiqué", en: "Undisclosed" },
    image:
      "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/tl3ukngs_Maison%20BACH-R%C3%A9alit%C3%A9.jpeg",
    description: {
      fr:
        "Le projet consiste en la rénovation complète d'une maison familiale, intégrant une extension contemporaine et une requalification de la façade, tout en préservant l'intégrité de la structure existante. L'intervention a été menée comme une véritable opération chirurgicale, nécessitant une grande précision dans l'exécution. La structure existante a été conservée et renforcée, avec des interventions ciblées telles que la découpe minutieuse des poutres existantes afin d'intégrer les nouveaux volumes sans compromettre la stabilité de l'ensemble. Ce travail fin a permis d'articuler harmonieusement l'ancien et le contemporain, en modernisant l'image du bâti tout en respectant son histoire et ses contraintes constructives.",
      en:
        "The project consists of the complete renovation of a family home, including a contemporary extension and a facade requalification, while preserving the integrity of the existing structure. The intervention was conducted as a true surgical operation, requiring great precision in execution. The existing structure was preserved and reinforced, with targeted interventions such as the meticulous cutting of existing beams to integrate the new volumes without compromising overall stability. This refined work harmoniously articulates the old and the contemporary, modernizing the building's image while respecting its history and constructive constraints.",
    },
    gallery: [
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/ux1xt79v_Animation%20Maison%20BACH.mp4",
        kind: "video",
        label: { fr: "Animation 3D — Maison BACH", en: "3D Animation — BACH House" },
        type: "animation",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/tl3ukngs_Maison%20BACH-R%C3%A9alit%C3%A9.jpeg",
        kind: "image",
        label: { fr: "Réalisation — Photo de chantier", en: "Built — Construction photo" },
        type: "photo",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/qpj75xmr_Maison%20BACH-3D.jpeg",
        kind: "image",
        label: { fr: "Modélisation 3D — Repérage X1–X8", en: "3D model — X1–X8 reference" },
        type: "drawing",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/bh5m8yzy_Maison%20BACH%20001.jpeg",
        kind: "image",
        label: { fr: "Méthode — Existant · Démolition · Extension", en: "Method — Existing · Demolition · Extension" },
        type: "board",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/184zbods_Maison%20BACH%20002.jpeg",
        kind: "image",
        label: { fr: "Planche conceptuelle — Maquette & élévations", en: "Concept board — Model & elevations" },
        type: "board",
      },
    ],
  },
  {
    id: "brumath-coeur-ilot",
    title: {
      fr: "Brumath — Réhabilitation grange & cœur d'îlot",
      en: "Brumath — Barn rehabilitation & infill housing",
    },
    category: "residential",
    year: "2021",
    location: "Brumath (67170), FR",
    scope: "Réhabilitation · 4 logements + 5 maisons · Parking sous-sol",
    surface: "9 logements",
    image:
      "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/oiep23jj_Logement%20BRUMATH%20ILLUSTRATION.jpeg",
    description: {
      fr:
        "Requalification d'une grange existante et développement d'un ensemble résidentiel en cœur d'îlot. L'intervention vise à redonner vie à une ancienne grange en la transformant en un programme résidentiel composé de quatre logements. Cette réhabilitation s'inscrit dans une logique de valorisation du bâti existant, en conservant son identité tout en l'adaptant aux standards contemporains de confort et de performance. En complément, le projet prévoit la création d'un ensemble de cinq maisons individuelles en fond de parcelle, organisées en cœur d'îlot — réflexion globale d'optimisation du foncier et de densification douce. L'aménagement intègre une accessibilité optimisée avec une desserte claire et fonctionnelle des logements, ainsi qu'un parking en sous-sol qui libère les espaces extérieurs au profit de la qualité paysagère. L'ensemble s'inscrit dans une démarche cohérente de renouvellement urbain conciliant réhabilitation du patrimoine et offre résidentielle contemporaine.",
      en:
        "Rehabilitation of an existing barn and development of a residential complex in the heart of the block. The intervention brings new life to an old barn by transforming it into a residential program of four dwellings. This rehabilitation is part of a logic of enhancing the existing built fabric, preserving its identity while adapting it to contemporary comfort and performance standards. The project also creates a set of five individual houses at the back of the plot, organised within the block — a comprehensive reflection on land optimisation and gentle densification. The layout integrates optimised accessibility, clear and functional access to all dwellings, and an underground parking that frees outdoor spaces for landscape quality. The whole project follows a coherent urban renewal approach, combining heritage rehabilitation and contemporary residential offer.",
    },
    gallery: [
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/oiep23jj_Logement%20BRUMATH%20ILLUSTRATION.jpeg",
        kind: "image",
        label: { fr: "Illustration — Coupe immersive nocturne", en: "Illustration — Immersive night section" },
        type: "render",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/8la4fdoy_Logement%20BRUMATH%20PLACHE%20001.jpg",
        kind: "image",
        label: { fr: "Planche 01 — Élévations & coupes 1:100", en: "Board 01 — Elevations & sections 1:100" },
        type: "drawing",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_laka-design-refresh/artifacts/3ch6tmmn_Logement%20BRUMATH%20PLACHE%20002.jpg",
        kind: "image",
        label: { fr: "Planche 02 — Plan masse & axonométrie éclatée", en: "Board 02 — Site plan & exploded axonometry" },
        type: "drawing",
      },
    ],
  },
  {
    id: "p3",
    title: { fr: "Cuisine Épurée — Rénovation", en: "Pared-back Kitchen — Renovation" },
    category: "renovation",
    year: "2024",
    location: "Mulhouse, FR",
    scope: "Rénovation complète",
    image:
      "https://images.pexels.com/photos/19548561/pexels-photo-19548561.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "p4",
    title: { fr: "Salon Lin — Résidence privée", en: "Linen Lounge — Private Residence" },
    category: "residential",
    year: "2023",
    location: "Luxembourg",
    scope: "Design intérieur · BIM",
    image:
      "https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwaW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8fHwxNzc2NzE5Mjk0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p5",
    title: { fr: "Villa Horizon — Maison individuelle", en: "Horizon Villa — Individual House" },
    category: "residential",
    year: "2022",
    location: "Colmar, FR",
    scope: "Conception · Permis · OPC",
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "logements-38-sainte-marie",
    title: {
      fr: "Réhabilitation — 38 logements collectifs",
      en: "Rehabilitation — 38 collective housing units",
    },
    category: "renovation",
    year: "2024",
    location: "Sainte-Marie-aux-Mines, FR",
    scope: "Appel d'offres · Réhabilitation · BIM · Coordination MOE",
    surface: "38 logements · 02 bâtiments · R+4",
    image: "/projects/logements-38/cover-rendu.webp",
    gallery: [
      {
        url: "/projects/logements-38/cover-rendu.webp",
        label: {
          fr: "Vue d'ambiance — 83 & 85 rue Saint-Louis au crépuscule",
          en: "Ambient view — 83 & 85 rue Saint-Louis at dusk",
        },
        type: "rendu photoréaliste",
      },
      {
        url: "/projects/logements-38/vue-360.mp4",
        kind: "video",
        label: {
          fr: "Vidéo 360° — Rotation immersive autour des bâtiments",
          en: "360° video — Immersive rotation around the buildings",
        },
        type: "vidéo · 360°",
      },
      {
        url: "/projects/logements-38/planche-01-ensemble.webp",
        label: {
          fr: "Planche 01/03 — Vue d'ensemble & façades (courante / sur rue)",
          en: "Plate 01/03 — Overview & facades (standard / street)",
        },
        type: "planche · vue d'ensemble",
      },
      {
        url: "/projects/logements-38/planche-02-coupe.webp",
        label: {
          fr: "Planche 02/03 — Coupe & structure métallique rapportée · matériaux",
          en: "Plate 02/03 — Section & added steel structure · materials",
        },
        type: "planche · coupe · matériaux",
      },
      {
        url: "/projects/logements-38/planche-03-planning.webp",
        label: {
          fr: "Planche 03/03 — Planning prévisionnel des travaux (2024 → 2025)",
          en: "Plate 03/03 — Provisional works schedule (2024 → 2025)",
        },
        type: "planning · Gantt",
      },
      {
        url: "/projects/logements-38/planche-technique-complete.webp",
        label: {
          fr: "Planche technique complète — Étude BIM de réhabilitation",
          en: "Complete technical plate — BIM rehabilitation study",
        },
        type: "planche architecte",
      },
    ],
    description: {
      fr:
        "Appel d'offres pour la réhabilitation de deux immeubles collectifs — 38 logements répartis sur R+4 — situés au 83 & 85 rue Saint-Louis à Sainte-Marie-aux-Mines. L'étude BIM engage une lecture commune du site : structure métallique rapportée pour les balcons, nouvelle lecture des façades par jeu d'ombres/pleins/vides, intervention lisible sur l'enveloppe (bardage isolant panneaux minéraux RAL 9001, bardage briques Vandersanden, enduit STO), et maîtrise constructive coordonnée avec les vues 3D. Un planning prévisionnel étalé de février 2024 à février 2025 accompagne l'ensemble : immeubles → logements → parties communes → mise en sécurité électrique → OPR & réception.",
      en:
        "Public tender for the rehabilitation of two collective buildings — 38 units on R+4 — at 83 & 85 rue Saint-Louis in Sainte-Marie-aux-Mines. The BIM-driven study delivers a shared reading of the site: an added steel structure carrying the balconies, a new facade rhythm mastered through repetition and solid/void interplay, a legible envelope intervention (mineral-panel insulating cladding RAL 9001, Vandersanden brick cladding, STO render), and constructive coordination driven by the 3D model. A provisional schedule spanning February 2024 → February 2025 orchestrates the works: buildings → dwellings → common areas → electrical safety → final inspection & handover.",
    },
  },
  {
    id: "maison-im-zug",
    title: {
      fr: "Maison Im Zug — Étude APS",
      en: "Im Zug House — Preliminary study",
    },
    category: "residential",
    year: "2024",
    location: "Strasbourg, FR",
    scope: "Maison individuelle · APS · Charpente maîtrisée · Volumétrie",
    surface: "R+1 · Combles habitables",
    budget: "200K €",
    image: "/projects/imzug/cover-perspective.webp",
    gallery: [
      {
        url: "/projects/imzug/cover-perspective.webp",
        label: {
          fr: "Vue principale — Perspective extérieure",
          en: "Main view — Exterior perspective",
        },
        type: "perspective",
      },
      {
        url: "/projects/imzug/vue-3d-charpente.webp",
        label: {
          fr: "Vue 3D — Charpente & structure",
          en: "3D view — Framing & structure",
        },
        type: "structure",
      },
      {
        url: "/projects/imzug/synthese-volumetrique.webp",
        label: {
          fr: "Synthèse volumétrique — RDC & R+1",
          en: "Volumetric synthesis — Ground & first floor",
        },
        type: "volumétrie",
      },
      {
        url: "/projects/imzug/plan-toiture.webp",
        label: {
          fr: "Plan de toiture — vue en plan",
          en: "Roof plan — top view",
        },
        type: "plan · toiture",
      },
      {
        url: "/projects/imzug/coupes.webp",
        label: {
          fr: "Coupes 01 & 02 — Échelle 1/100",
          en: "Sections 01 & 02 — Scale 1/100",
        },
        type: "coupes · 1/100",
      },
      {
        url: "/projects/imzug/planche-01.webp",
        label: {
          fr: "Planche 01 — Perspectives & synthèse volumétrique",
          en: "Plate 01 — Perspectives & volumetric synthesis",
        },
        type: "planche architecte",
      },
      {
        url: "/projects/imzug/planche-02.webp",
        label: {
          fr: "Planche 02 — Plan de toiture & coupes",
          en: "Plate 02 — Roof plan & sections",
        },
        type: "planche architecte",
      },
    ],
    description: {
      fr:
        "Berlin → Strasbourg. Un trajet, une maison qui prend forme. Étude d'une maison de campagne où charpente, toiture et grands espaces de vie construisent l'identité du projet. Une charpente maîtrisée dès la conception, anticipation des assemblages et mise en œuvre simplifiée sur chantier. Une maison contemporaine au service du cadre de vie — organisation claire du RDC autour d'un séjour traversant, distribution intime des chambres à l'étage, et volume de toiture rouge affirmant une silhouette lisible depuis la rue.",
      en:
        "Berlin → Strasbourg. A journey, a house taking shape. Study of a country house where framing, roof and generous living spaces build the project's identity. A framing strategy mastered from the design phase — joints anticipated, on-site execution simplified. A contemporary house serving daily life — clear ground-floor organisation around a through-living space, an intimate distribution of bedrooms upstairs, and a red-roof volume asserting a legible silhouette from the street.",
    },
  },
  {
    id: "hangar-atelier-anglure",
    title: {
      fr: "Hangar — Atelier d'entretien & parking fermé",
      en: "Hangar — Maintenance workshop & closed parking",
    },
    category: "commercial",
    year: "2024",
    location: "La Campagne d'Anglure, FR",
    scope: "Hangar industriel · Atelier · Parking clôturé · Permis de construire",
    surface: "Sections 351 · 363 · 567",
    image: "/projects/hangar/cover-perspective.webp",
    gallery: [
      {
        url: "/projects/hangar/hero-perspective.webp",
        label: {
          fr: "Perspective d'ensemble — vue aérienne",
          en: "Overall perspective — aerial view",
        },
        type: "perspective",
      },
      {
        url: "/projects/hangar/planche-01.webp",
        label: {
          fr: "Planche 01 — Perspective, coupe & élévations",
          en: "Plate 01 — Perspective, section & elevations",
        },
        type: "planche architecte",
      },
      {
        url: "/projects/hangar/planche-02.webp",
        label: {
          fr: "Planche 02 — Plan de situation & plan de masse",
          en: "Plate 02 — Site plan & massing plan",
        },
        type: "planche architecte",
      },
      {
        url: "/projects/hangar/plan-masse.webp",
        label: {
          fr: "Plan de masse — Échelle 1/500",
          en: "Massing plan — Scale 1/500",
        },
        type: "plan · 1/500",
      },
      {
        url: "/projects/hangar/insertion-urbaine.webp",
        label: {
          fr: "Insertion paysagère — vue aérienne du site",
          en: "Landscape insertion — aerial site view",
        },
        type: "insertion",
      },
      {
        url: "/projects/hangar/cover-perspective.webp",
        label: {
          fr: "Perspective d'ambiance — Route de Normée",
          en: "Ambient perspective — Route de Normée",
        },
        type: "rendu",
      },
    ],
    description: {
      fr:
        "Atelier d'entretien et parking fermé pour l'entreprise Transports Z. Stopha, implanté sur les parcelles 351 · 363 · 567 à La Campagne d'Anglure (Route de Normée × Route de Champagobert). Le projet combine un hangar industriel à double travée pour la maintenance des véhicules poids-lourds, une zone bureaux/vestiaires accolée, et un vaste parking clôturé pour le stationnement de la flotte. L'écriture architecturale — volume bardé sombre, toiture asymétrique intégrant des panneaux photovoltaïques — répond à la fois aux exigences fonctionnelles du programme (grande hauteur, accès poids-lourds, sécurité périmétrique) et à une bonne insertion dans le paysage rural.",
      en:
        "Maintenance workshop and closed parking for Transports Z. Stopha, located on plots 351 · 363 · 567 at La Campagne d'Anglure (Route de Normée × Route de Champagobert). The project combines a double-bay industrial hangar for HGV maintenance, an adjoining office and locker area, and a large fenced parking for the fleet. The architectural approach — dark cladding, asymmetric roof integrating PV panels — responds both to the program's functional demands (headroom, HGV access, perimeter security) and to a careful integration into the rural landscape.",
    },
  },
];
